import { UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { CatalogCreationAccessFieldName } from '../../../modules/catalogs/creation/catalogCreationAccess.types';

export const CATALOG_ACCESS_QUERY_KEY = 'catalogs/:id/access';

interface CatalogAccessKeyParams {
  catalogId: string;
  field: CatalogCreationAccessFieldName;
}

export const getFindCatalogAccessEntitiesKey = ({
  catalogId,
  field,
}: CatalogAccessKeyParams): UseDataQueryKey => [CATALOG_ACCESS_QUERY_KEY, catalogId, field];

export const getInfiniteCatalogAccessEntitiesKey = ({
  catalogId,
  field,
}: CatalogAccessKeyParams): UseDataQueryKey => [
  CATALOG_ACCESS_QUERY_KEY,
  catalogId,
  field,
  'infinite',
];
